<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted, watch } from 'vue'

  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginExecutionConfirmation from '../composables/usePluginExecutionConfirmationModal'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'
  import { useEmbedConfig } from '@/composables'

  const modalControlStore = useModalControl()
  const { showPluginExecutionConfirmation, hidePluginExecutionConfirmation } =
    usePluginExecutionConfirmation()

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const hasIssuedAt = ref(false)
  const pluginStore = ref()
  const { isEmbedMode } = useEmbedConfig()

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-download-confirmation', {
      backdrop: 'static',
      keyboard: false,
    })

    pluginStore.value = usePlugin()

    hasIssuedAt.value =
      pluginStore.value.certificateIssuedAtWasChecked &&
      pluginStore.value.issuedAt?.trim()?.length > 0
  })

  watch(
    () =>
      pluginStore.value?.certificateIssuedAtWasChecked &&
      pluginStore.value?.issuedAt?.trim()?.length > 0,
    (value) => {
      if (value) {
        hasIssuedAt.value = value
      }
    },
  )

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function proceed() {
    hide()
    modalControlStore.show({
      modalId: 'pluginExecutionConfirmation',
      show: showPluginExecutionConfirmation,
      hide: hidePluginExecutionConfirmation,
    })
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-plugin-download-confirmation"
    class="modal modal-md fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body py-3 pt-5">
          <img alt="sucesso" src="../assets/success-girl-2.svg" />

          <p class="fs-6 text-center mt-4">
            <strong>Oba, você baixou o plugin!</strong>
          </p>

          <p v-if="!hasIssuedAt" class="fs-6 text-center mt-4">
            Ele é
            <strong>essencial</strong>
            para a
            <strong>
              emissão do seu Certificado Digital{{ isEmbedMode ? '' : ' A1' }}.
            </strong>
          </p>

          <p v-else class="fs-6 text-center mt-4">
            Ele é
            <strong>
              essencial para baixar o Certificado{{ isEmbedMode ? '' : ' A1' }}
            </strong>
            no seu computador.
          </p>
        </div>
        <div class="modal-footer py-3">
          <button class="btn btn-primary" type="button" @click="proceed">
            {{ isEmbedMode ? 'Siguiente' : 'Avançar' }}
            <icon-component name="arrow-right" class="ms-2" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .contact-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    width: 100%;
  }

  .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    border: 1px solid #e6e7ec;
    border-radius: 10px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
